import { ValueNode } from './ValueNode';
export class AnnotationNode extends ValueNode {
    value;
    attributes;
    originalEdges = new Map();
    constructor(id, value, key, metadata, attributes = []) {
        super(id, key, metadata);
        this.value = value;
        this.attributes = attributes;
    }
    clearOriginalEdges() {
        this.originalEdges = new Map();
    }
    addOriginalEdge(edge) {
        this.originalEdges.set(edge.to, edge);
    }
    getOriginalEdge(targetId) {
        return this.originalEdges.get(targetId);
    }
    getOriginalEdges() {
        return this.originalEdges;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW5ub3RhdGlvbk5vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL3JlY29yZC9Bbm5vdGF0aW9uTm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBS3ZDLE1BQU0sT0FBTyxjQUVYLFNBQVEsU0FBUztJQUNqQixLQUFLLENBQVE7SUFDYixVQUFVLENBQWtCO0lBQ3BCLGFBQWEsR0FBc0IsSUFBSSxHQUFHLEVBQUUsQ0FBQTtJQUVwRCxZQUNFLEVBQVUsRUFDVixLQUFhLEVBQ2IsR0FBWSxFQUNaLFFBQW1CLEVBQ25CLGFBQStCLEVBQUU7UUFFakMsS0FBSyxDQUFDLEVBQUUsRUFBRSxHQUFHLEVBQUUsUUFBUSxDQUFDLENBQUE7UUFDeEIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7UUFDbEIsSUFBSSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUE7SUFDOUIsQ0FBQztJQUVNLGtCQUFrQjtRQUN2QixJQUFJLENBQUMsYUFBYSxHQUFHLElBQUksR0FBRyxFQUFFLENBQUE7SUFDaEMsQ0FBQztJQUVNLGVBQWUsQ0FBQyxJQUFVO1FBQy9CLElBQUksQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQUE7SUFDdkMsQ0FBQztJQUVNLGVBQWUsQ0FBQyxRQUFnQjtRQUNyQyxPQUFPLElBQUksQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxDQUFBO0lBQ3pDLENBQUM7SUFFTSxnQkFBZ0I7UUFDckIsT0FBTyxJQUFJLENBQUMsYUFBYSxDQUFBO0lBQzNCLENBQUM7Q0FDRiJ9